/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Popover, Menu } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import Icon from '../Icons';
import { PUBLIC_ID, PLANNED_ID } from '../CreateIncident/constant';

const ButtonWithMenu = props => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenuOption = option => {
    props.createIncident(option);
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        onClick={e => setAnchorEl(e.currentTarget)}
        aria-describedby="create-incident"
        type="secondary"
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      >
        {t('components.globalTopNav.newButton')}&nbsp;
        <Icon size={12} glyph="arrowdown" />
      </Button>
      <Popover
        id="create-incident"
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        <Menu
          options={[
            {
              id: PUBLIC_ID,
              name: t('components.globalTopNav.incident')
            },
            {
              id: PLANNED_ID,
              name: t('components.globalTopNav.scheduledMaintenance')
            }
          ]}
          onSelect={v => handleMenuOption(v)}
        />
      </Popover>
    </>
  );
};

export default ButtonWithMenu;
